import { createFileRoute } from '@tanstack/react-router';
import ApplicationPage from '@/pages/application/application-page';

export const Route = createFileRoute('/_protected/application/')({
  component: ApplicationPage,
});
